module.exports = __webpack_public_path__ + "static/img/3.29e438bb.jpg";